<header class="app-header">
  <div class="container app-header__inner">
    <a routerLink="/" class="brand" aria-label="Recrutamento Ético">
      <img class="brand__logo" src="/re-icon.png" alt="Recrutamento Ético" />
    </a>

    <div class="app-actions">
      @if (currentUser()) {
        <a routerLink="/reports/new" class="btn btn--primary">
          Submeter relatório
        </a>

        <div class="account-menu" tabindex="0">
          <button class="account-trigger" type="button" aria-haspopup="true">
            {{ userInitials() }}
          </button>
          <div class="account-dropdown">
            <div class="account-email">{{ currentUser()?.email }}</div>
            <div class="account-links">
              <a routerLink="/dashboard" routerLinkActive="active">Meus Relatórios</a>
              @if (isModerator()) {
                <a routerLink="/moderation" routerLinkActive="active">Moderação</a>
              }
              @if (isAdmin()) {
                <a routerLink="/moderation/breadcrumbs" routerLinkActive="active">Breadcrumbs</a>
              }
              <button (click)="logout()" type="button">Sair</button>
            </div>
          </div>
        </div>
      } @else {
        <a routerLink="/reports/new" class="btn btn--primary">Submeter relatório</a>
        <a routerLink="/login" class="btn btn--secondary">Entrar</a>
      }
    </div>
  </div>
</header>

<main class="main-content">
  <router-outlet />
</main>

<footer class="footer">
  <div class="container footer__inner">
    <div class="footer-links">
      <a routerLink="/privacy">Política de Privacidade</a>
      <a routerLink="/terms">Termos de Serviço</a>
      <a routerLink="/transparencia-salarial">Transparência Salarial (UE 2023/970)</a>
      <a routerLink="/sinais">Sinais no Recrutamento</a>
    </div>
    <p class="footer-note">&copy; 2026 Recrutamento Ético - Transparência no Recrutamento</p>
  </div>
</footer>
